import { inject } from '@angular/core';
import { HttpEvent, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ENCRYPTION_MODE } from './encryption-mode';
import { CryptoService } from '@core/services/crypto.service';

export const encryptionInterceptor: HttpInterceptorFn = (req, next) => {

  if (req.url.includes('https://buzz.rnfi.in/api/')) {
    return next(req);
  }
  const plainbody = req.body;
  const _CryptoService = inject(CryptoService);
  const encryptionMode = inject(ENCRYPTION_MODE).get();

  const shouldEncrypt = encryptionMode === 1 || req.url.includes('shouldEncrypt');


  // encrypt request body
  if (shouldEncrypt) {
    const encrypted = _CryptoService.Encrypt(req.body);

    req = req.clone({
      body: encrypted
    });
  }

  // decrypt response body
  return next(req).pipe(
    map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse && shouldEncrypt) {
        try {
          const decrypted = _CryptoService.Decrypt(event.body, req.url.includes('auth/login'));

          if (true) {
            console.group('Encryption Interceptor start');
            console.log('req.url', req.url);

            console.log('plain body', plainbody);
            console.log('plain response', JSON.parse(decrypted));
            console.groupEnd();
          }

          return event.clone({ body: JSON.parse(decrypted) });
        } catch {
          return event;
        }
      }
      return event;
    })
  );
};
